document.addEventListener("DOMContentLoaded", function () {

    // Ajout du CSS directement via JavaScript
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes highlight {
        0% { background-color: green; }
        100% { background-color: transparent; }
      }

      .highlight {
        animation: highlight 1s ease-out;
      }
    `;
    document.head.appendChild(style);

    // Script principal
    const originElement = document.getElementById("variant-origin");
    const variantInputsSelector = 'input[name="option-1"]';

    if (!originElement) {
        console.error("Élément pour afficher l'origine introuvable.");
        return;
    }

    function updateOrigin() {
        console.log("Mise à jour de l'origine déclenchée.");

        const selectedInput = document.querySelector('input[name="option-1"]:checked');
        if (!selectedInput) {
            console.error("Aucun bouton radio sélectionné.");
            return;
        }

        const selectedVariantTitle = selectedInput.value;
        const selectedVariant = window.product?.variants.find(
            variant => variant.title === selectedVariantTitle
        );

        if (selectedVariant && selectedVariant.metafields?.custom?.origine) {
            let originValue = selectedVariant.metafields.custom.origine;
            originValue = originValue.replace(/&quot;/g, '').replace(/^\[|]$/g, "");

            console.log("Origine décodée :", originValue);

            // Vérifiez si l'élément est accessible et visible
            if (originElement) {
                const style = window.getComputedStyle(originElement);
                console.log("Styles de l'élément :", style);

                if (style.display === "none" || style.visibility === "hidden") {
                    originElement.style.display = "block";
                    originElement.style.visibility = "visible";
                }

                // Modifiez le texte de l'élément
                //originElement.innerText = `Origine : ${originValue}`;
                document.getElementById("variant-origin").innerText = `Origine : ${originValue}`;
                
                // Ajouter la classe highlight pour déclencher l'animation
                document.getElementById("variant-origin").classList.add("highlight");
    
                // Supprimer la classe après la durée de l'animation
                setTimeout(() => {
                    document.getElementById("variant-origin").classList.remove("highlight");
                }, 1000); // Durée de l'animation

                //var highlightElement = document.getElementById("variant-origin");

                //highlightElement.addEventListener('mouseenter', () => {
                //    highlightElement.style.backgroundColor = 'yellow';
                //});
        
                //highlightElement.addEventListener('mouseleave', () => {
                //  highlightElement.style.backgroundColor = '';
                //});
              
                console.log("Contenu après modification :", originElement.textContent);
            }
        } else {
            console.warn("Aucune origine spécifiée pour cette variante.");
            originElement.textContent = "Origine : Non spécifiée";
        }
    }

    // Attacher les écouteurs et observer les changements dynamiques
    function attachListeners() {
        const variantInputs = document.querySelectorAll(variantInputsSelector);
        variantInputs.forEach(function (input) {
            input.addEventListener("change", function (event) {
                event.stopImmediatePropagation();
                console.log("Changement détecté :", input.value);
                updateOrigin();
            });
        });
    }

    const observer = new MutationObserver(() => {
        attachListeners();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    attachListeners();
    updateOrigin();
});
